import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

export const languageSlice = createSlice({
  name: 'language',
  initialState: {
    currentLanguage: 'en',
    languagesLinks: null,
    isLang: false,
    defaultLinks: null,
  },
  reducers: {
    setLang: (state, action) => {
      state.currentLanguage = action.payload
    },
    setLanguagesLinks: (state, action) => {
      state.languagesLinks = action.payload
    },
    setDefaultLanguages: (state, action) => {
      state.defaultLinks = action.payload
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      const { language } = action.payload

      return {
        ...state,
        languagesLinks: language.languagesLinks,
        defaultLinks: language.defaultLinks,
      }
    },
  },
})

export const { setLang, setLanguagesLinks, setDefaultLanguages } =
  languageSlice.actions

export default languageSlice.reducer
